
import { formatDistanceToNow } from "@/utils/date-utils";
import Vue from "vue";


export default Vue.extend({
	props: {
		datetime: {
			type: Date as ()=> any as () => Date,
			required: true
		}
	},
	computed: {
		output():string{
			return formatDistanceToNow(this.datetime);
		}
	}
});
